import React from 'react';
import { ResumePage } from './components/ResumePage';
export function App() {
  return <ResumePage data-id="element-0" />;
}